import PaginationState from './pagination-state';
import Action from '../../state/action';

const nextPage = (state: PaginationState): number => Math.min(state.pageCount, state.currentPage + 1);

const paginationReducer = (state: PaginationState, action: Action): PaginationState => {
  switch (action.type) {
    case 'reset-pagination':
      return {
        ...state,
        max: Math.min(action.pageSize, action.total),
        total: action.total,
        pageSize: action.pageSize,
        pageCount: Math.ceil(action.total / (action.pageSize || 1)),
        currentPage: 1,
        hasNext: action.pageSize < action.total,
      };
    case 'next-page':
      return {
        ...state,
        max: Math.min(nextPage(state) * state.pageSize, state.total),
        currentPage: nextPage(state),
        hasNext: nextPage(state) < state.pageCount,
      };
    default:
      return state;
  }
};

export default paginationReducer;
